import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const OTPRI_Approval = () => {
  const [data, setData] = useState(null);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    const apiPath = getAPIPath(currentDomain)?.approval;
    fetchData(apiPath, setData);
  }, [currentDomain]);

  // Function to render rich text content
  const renderRichText = (content) => {
    if (!content || !Array.isArray(content)) return null;

    return content.map((block, blockIndex) => {
      if (block.type === "paragraph") {
        return (
          <p key={blockIndex} className="mb-3">
            {block.children?.map((child, childIndex) => {
              if (child.type === "text") {
                let text = child.text;
                
                // Apply formatting
                if (child.bold) {
                  text = <strong key={childIndex}>{text}</strong>;
                }
                if (child.italic) {
                  text = <em key={childIndex}>{text}</em>;
                }
                if (child.underline) {
                  text = <u key={childIndex}>{text}</u>;
                }
                
                return text;
              }
              return child.text || "";
            })}
          </p>
        );
      } else if (block.type === "list") {
        const ListTag = block.format === "ordered" ? "ol" : "ul";
        
        return (
          <ListTag key={blockIndex} className="approval-list mb-4">
            {block.children?.map((listItem, itemIndex) => {
              if (listItem.type === "list-item") {
                return (
                  <li key={itemIndex} className="approval-item mb-2">
                    {listItem.children?.map((child, childIndex) => {
                      if (child.type === "text") {
                        let text = child.text;
                        
                        // Apply formatting
                        if (child.bold) {
                          text = <strong key={childIndex}>{text}</strong>;
                        }
                        if (child.italic) {
                          text = <em key={childIndex}>{text}</em>;
                        }
                        if (child.underline) {
                          text = <u key={childIndex}>{text}</u>;
                        }
                        
                        return text;
                      }
                      return child.text || "";
                    })}
                  </li>
                );
              }
              return null;
            })}
          </ListTag>
        );
      } else if (block.type === "heading") {
        const HeadingTag = `h${block.level || 3}`;
        return (
          <HeadingTag key={blockIndex} className="mb-3">
            {block.children?.map((child, childIndex) => {
              if (child.type === "text") {
                return child.text;
              }
              return "";
            })}
          </HeadingTag>
        );
      }
      
      return null;
    });
  };

  const approvalData = data?.data?.attributes;

  return (
    <React.Fragment>
      <Helmet>
        <title>Approval | OTPRI | JNTU Anantapur</title>
        <meta
          name="description"
          content="Approval details of Oil Technological & Pharmaceutical Research Institute, JNTUA"
        />
        <meta
          name="keywords"
          content="Approval, OTPRI, Oil Technological, Pharmaceutical Research Institute, JNTUA, AICTE, PCI"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }

                    .approval-list {
                        padding-left: 0;
                        list-style: none;
                    }
                    
                    .approval-item {
                        position: relative;
                        padding: 15px 20px 15px 50px;
                        margin-bottom: 15px;
                        border-left: 4px solid #007bff;
                        border-radius: 8px;
                        background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
                        box-shadow: 0 2px 8px rgba(0,123,255,0.1);
                        transition: all 0.3s ease;
                        font-weight: 500;
                    }
                    
                    .approval-item:hover {
                        transform: translateX(8px);
                        box-shadow: 0 4px 15px rgba(0,123,255,0.2);
                        border-left-color: #0056b3;
                    }
                    
                    .approval-item::before {
                        content: '✓';
                        position: absolute;
                        left: 18px;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #007bff;
                        font-size: 20px;
                        font-weight: bold;
                        width: 24px;
                        height: 24px;
                        background: #e3f2fd;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all 0.3s ease;
                    }

                    .approval-item:hover::before {
                        background: #007bff;
                        color: white;
                        transform: translateY(-50%) scale(1.1);
                    }

                    .section-container {
                        background: #fff;
                        padding: 40px;
                        border-radius: 12px;
                        box-shadow: 0 4px 20px rgba(0,0,0,0.1);
                        margin-bottom: 30px;
                        border-top: 4px solid #007bff;
                    }

                    .section-title {
                        color: #007bff;
                        font-weight: 600;
                        margin-bottom: 25px;
                        padding-bottom: 15px;
                        border-bottom: 2px solid #e9ecef;
                        position: relative;
                    }

                    .section-title::after {
                        content: '';
                        position: absolute;
                        bottom: -2px;
                        left: 0;
                        width: 50px;
                        height: 2px;
                        background: #007bff;
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Approval"
          pageName="Approval"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title">Approval Details</h3>
                    
                    {approvalData?.section?.map((section, index) => (
                      <div key={section.id || index} className="section-container">
                        {section.title && (
                          <h4 className="section-title">{section.title}</h4>
                        )}
                        <div className="section-content">
                          {renderRichText(section.content)}
                        </div>
                      </div>
                    ))}
                    
                    {(!approvalData?.section || approvalData?.section?.length === 0) && (
                      <div className="section-container">
                        <div className="text-center" style={{ padding: "60px 20px", color: "#666" }}>
                          <i className="fas fa-certificate" style={{ fontSize: "48px", marginBottom: "20px", color: "#ddd" }}></i>
                          <br />
                          <h5 style={{ color: "#999", fontWeight: "normal" }}>No approval information available at the moment.</h5>
                          <p style={{ color: "#bbb", fontSize: "14px" }}>Please check back later for updates.</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default OTPRI_Approval;